<template>
    <img src="/templates/xhtml/krainaabc/src/assets/images/letters/z-rebak.png" alt="">
</template>

<script>
export default {
    name: 'LetterZ',
};
</script>
